import { createFileRoute } from '@tanstack/react-router';

import { NewPortfolioWizard } from '~/components/portfolio/new-portfolio-wizard/new-portfolio-wizard.tsx';
import { getNewPortfolioPageData } from '~/server/portfolio/get-new-portfolio-page-data.ts';

export const Route = createFileRoute('/portfolios/new')({
	component: NewPortfolioPage,
	head: () => ({
		meta: [{ title: 'Create New Portfolio' }],
	}),
	loader: () => getNewPortfolioPageData(),
});

function NewPortfolioPage() {
	return <NewPortfolioWizard />;
}
